import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { mergeProps } from '@react-aria/utils';
import { isSelected } from '../helpers/Select.helpers.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSelectFormField = function useSelectFormField(props) {
  var rootProps = props.rootProps,
    selectProps = props.selectProps,
    selectPopoverProps = props.selectPopoverProps,
    controlContainerProps = props.controlContainerProps,
    clearButtonProps = props.clearButtonProps,
    validation = props.validation;
  var controlContainerRef = React.useRef(null);

  // Value
  var defaultValue = (selectProps === null || selectProps === void 0 ? void 0 : selectProps.selectedKeys) || new Set([]);
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selected = _React$useState2[0],
    setSelected = _React$useState2[1];

  // Validation
  var _React$useState3 = React.useState((validation === null || validation === void 0 ? void 0 : validation.checkValidity(selected)) || {
      isValid: true,
      message: ''
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    validationResult = _React$useState4[0],
    setValidationResult = _React$useState4[1];

  // State
  var _React$useState5 = React.useState((rootProps === null || rootProps === void 0 ? void 0 : rootProps.state) || 'default'),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    state = _React$useState6[0],
    setState = _React$useState6[1];

  // Reset form field value
  var resetFormField = React.useCallback(function () {
    setSelected(new Set([]));
  }, []);

  // Focus first interactive element in the form field
  var focusFirstInteractiveElement = React.useCallback(function () {
    var _controlContainerRef$;
    (_controlContainerRef$ = controlContainerRef.current) === null || _controlContainerRef$ === void 0 || (_controlContainerRef$ = _controlContainerRef$.querySelector('button')) === null || _controlContainerRef$ === void 0 || _controlContainerRef$.focus();
  }, [controlContainerRef]);

  // Clear button props
  var clearButtonDefaultProps = React.useMemo(function () {
    return {
      onPress: function onPress() {
        resetFormField();
        focusFirstInteractiveElement();
      },
      isVisible: isSelected(selected)
    };
  }, [focusFirstInteractiveElement, resetFormField, selected]);

  // On selection change
  var handleSelectionChange = React.useCallback(function (selectedKeys) {
    var _selectProps$onSelect;
    var selectedSet = new Set(selectedKeys);
    setSelected(selectedSet);
    selectProps === null || selectProps === void 0 || (_selectProps$onSelect = selectProps.onSelectionChange) === null || _selectProps$onSelect === void 0 || _selectProps$onSelect.call(selectProps, new Set(selectedKeys));
    if (validation) {
      var _validation$checkVali = validation.checkValidity(selectedSet),
        isValid = _validation$checkVali.isValid,
        message = _validation$checkVali.message;
      setState(isValid ? 'success' : 'error');
      setValidationResult({
        isValid: isValid,
        message: message
      });
    }
  }, [selectProps, validation]);
  return {
    rootProps: _objectSpread(_objectSpread({}, rootProps), {}, {
      state: state
    }),
    selectProps: _objectSpread(_objectSpread({}, selectProps), {}, {
      selectedKeys: selected,
      onSelectionChange: handleSelectionChange
    }),
    selectPopoverProps: _objectSpread(_objectSpread({}, selectPopoverProps), {}, {
      controlContainerRef: controlContainerRef
    }),
    clearButtonProps: mergeProps(clearButtonDefaultProps, clearButtonProps),
    controlContainerProps: _objectSpread(_objectSpread({}, controlContainerProps), {}, {
      ref: controlContainerRef
    }),
    validationMessageProps: {
      validationResult: validationResult,
      controlContainerRef: controlContainerRef
    },
    utilityProps: {
      setState: setState,
      setSelected: setSelected,
      resetFormField: resetFormField,
      isSelected: isSelected
    },
    selectValue: {
      selected: selected
    }
  };
};

export { useSelectFormField };
//# sourceMappingURL=useSelectFormField.js.map
